module.exports = __webpack_public_path__ + "media/images/favicon-32x32-562653f260637ea50f9280781887488c.png";